import React, { useMemo } from "react";
import ServiceStatusValue from "kontrolEdge/components/Shared/ServiceStatusValue";
import { buildDetailSummary } from "./summaryModel";

type Sections = Parameters<typeof buildDetailSummary>[0];

/**
 * The head of a service detail on a phone (CTX-1421). On a 393 px screen the
 * status sat 400 to 680 px down, between the service's ID rows and its renewal
 * dates; here it is the first thing on the page. The cards hide their own
 * status rows below `sm`, so nothing is said twice.
 */
export function DetailSummary({ sections }: { sections: Sections }) {
  const summary = useMemo(() => buildDetailSummary(sections), [sections]);
  if (!summary.id && summary.chips.length === 0) return null;

  return (
    <section
      aria-label="Service summary"
      className="order-first mt-4 space-y-3 rounded-sm border border-semantic-border-secondary bg-semantic-bg-primary p-4 sm:hidden"
    >
      {summary.id && <p className="text-base font-semibold text-semantic-text-primary">{summary.id}</p>}
      {summary.chips.length > 0 && (
        <dl className="flex flex-wrap gap-x-4 gap-y-2">
          {summary.chips.map((chip) => (
            <div key={chip.label} className="flex items-center gap-2">
              <dt className="text-xs text-semantic-text-secondary">{chip.label}</dt>
              <dd>
                <ServiceStatusValue label={chip.value} variant={chip.variant} tooltip={chip.tooltip} />
              </dd>
            </div>
          ))}
        </dl>
      )}
      {summary.facts.length > 0 && (
        <p className="text-sm text-semantic-text-secondary">{summary.facts.join(" · ")}</p>
      )}
    </section>
  );
}
